/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

import Button from "@mui/material/Button";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import { useTransactionsContext } from "@zenith/context";
import { formatCurrency } from "@zenith/utils";
import {
  TRANSACTIONS,
  TRANSACTIONS_REFUND,
  TRANSACTIONS_REFUND_PIN,
} from "@zenith/routes/paths";
import {
  ApiResponseDTOOperationResFeeRecord,
  OperationFeeRecord,
  OperationsApiService,
} from "@zenith/services/transactions";
import { NOT_APPLICABLE_TEXT } from "@zenith/data/constants";
import CopyToClipboard from "@zenith/components/ui/CopyToClipboard/CopyToClipboard";

const RefundOverviewPage = memo(function RefundOverviewPage() {
  const navigate = useNavigate();
  const nameEnquiry: string = useLocation()?.state?.nameEnquiry;

  const { transactionsContext, setTransactionsContext } =
    useTransactionsContext();
  const {
    amount,
    bankName,
    beneficiaryName,
    feeValue,
    totalAmount,
    refundReason,
    transactionId,
    paymentMethod,
    operationId,
    beneficiaryAccountNumber,
    bankId,
    transactionType,
    nameEnquiryRef,
  } = transactionsContext;

  useEffect(() => {
    OperationsApiService.postOperationFee({
      amount,
      originalOperationId: operationId,
      beneficiary: {
        bank: {
          bankName,
          id: bankId,
        },
        accountNumber: beneficiaryAccountNumber,
        name: beneficiaryName,
      },
      currency: OperationFeeRecord.currency.NGN,
    })
      .then((response: ApiResponseDTOOperationResFeeRecord) => {
        if (response.success && amount === response.data?.amount) {
          setTransactionsContext({
            ...transactionsContext,
            amount: response.data.amount,
            feeValue: response.data.feeValue,
            totalAmount: response.data.totalAmount,
            nameEnquiryRef: nameEnquiry || nameEnquiryRef,
          });
        }
      })
      .catch((error) => console.error(error.message));
  }, []);

  if (!amount) {
    return <Navigate to={TRANSACTIONS} replace />;
  }

  function handleSubmit(): void {
    navigate(TRANSACTIONS_REFUND_PIN);
  }

  function handleBackButton(): void {
    navigate(TRANSACTIONS_REFUND);
  }

  return (
    <div className="mb-3 flex-col items-start justify-between ">
      <Button
        id="back-cart-summary"
        onClick={() => handleBackButton()}
        className="text-base font-normal normal-case text-neutral-600 hover:bg-white"
      >
        <ArrowBackIosIcon fontSize="small" /> Back
      </Button>
      <div className="m-auto mt-5 w-full rounded-[20px] border border-neutral-200 lg:w-3/5">
        <div className="rounded-2.5xl bg-white py-6 px-8">
          <div className=" flex-col justify-between">
            <h1 className="mb-8 text-2xl font-medium text-neutral-900">
              Refund Overview
            </h1>
          </div>
          <div className="text-xs md:text-base">
            <div className="flex flex-col gap-4 overflow-y-auto text-[#626262]">
              <div className="flex flex-row items-center justify-between">
                <span>Refund Type</span>
                <span className="font-medium text-zinc-900">Full Refund</span>
              </div>
              <div className="flex flex-row items-center justify-between">
                <span>Transaction Type</span>
                <span className="font-medium text-zinc-900">
                  {transactionType}
                </span>
              </div>
            </div>

            <hr className="my-4 border-stone-300" />

            <div className="flex flex-col gap-4 overflow-y-auto font-medium text-[#626262]">
              <div className="flex flex-row items-center justify-between">
                <span>Bank Name</span>
                <span className="font-medium text-zinc-900">{bankName}</span>
              </div>
              <div className="flex flex-row items-center justify-between">
                <span>Beneficiary Name</span>
                <span className="font-medium text-zinc-900">
                  {beneficiaryName}
                </span>
              </div>
              <div className="flex flex-row items-center justify-between">
                <span>Original Transaction ID</span>
                <CopyToClipboard
                  text={transactionId || NOT_APPLICABLE_TEXT}
                  className="font-medium text-zinc-900"
                />
              </div>
              <div className="flex flex-row items-center justify-between">
                <span>Refund Reason</span>
                <span className="font-medium text-zinc-900">
                  {refundReason || NOT_APPLICABLE_TEXT}
                </span>
              </div>
            </div>

            <hr className="my-4 border-stone-300" />
            <div className="flex flex-col gap-4 overflow-y-auto font-medium text-zinc-900">
              <div className="flex flex-row items-center justify-between">
                <strong>
                  <span>Amount</span>
                </strong>
                <span className="font-medium text-zinc-900">
                  {formatCurrency(amount)}
                </span>
              </div>
              <div className="flex flex-row items-center justify-between">
                <strong>
                  <span>Fees (VAT inclusive)</span>
                </strong>
                <span className="font-medium text-zinc-900">
                  {formatCurrency(feeValue)}
                </span>
              </div>
              <div className="mt-4 flex flex-row items-center justify-between">
                <strong>
                  <span>Total Amount</span>
                </strong>
                <span className="font-medium text-zinc-900">
                  {formatCurrency(totalAmount)}
                </span>
              </div>
            </div>

            <div className="mt-20 flex justify-center">
              <Button
                id="checkout-cart-button"
                className="h-12 w-large self-center rounded-lg bg-primary-300 py-3 px-10 text-base font-medium normal-case text-white hover:bg-primary-300"
                size="large"
                onClick={handleSubmit}
                // disabled={!feeValue}
              >
                Confirm
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default RefundOverviewPage;
